import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import Select from 'react-select';
import {
  Button, Card, Col, Form, Row,
} from 'react-bootstrap';
import useAPI from '../hooks/useAPI';
import SelectWithCustomInput from './SelectWithCustomInput/SelectWithCustomInput';
import Required from './Required';
import useToast from '../hooks/useToast';
import FindWithSelectComponent from './FindWithSelect/FindWithSelectComponent';
import { BaseRequests } from '../requests/BaseRequests';

function ReceiptsAddContract() {
  const api = useAPI();
  const [foundedValues, setFoundedValues] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [institutes, setInstitutes] = useState([]);
  const [selectedHead, setSelectedHead] = useState({});
  const [selectedValue, setSelectedValue] = useState({});
  const [selectedInstitute, setSelectedInstitute] = useState({});
  const { projId } = useParams();
  const [searchInstitute, setSearchInstitute] = useState('');
  const [topicName, setTopicName] = useState('');
  const [searchHeadValue, setSearchHeadValue] = useState('');
  const history = useHistory();
  const location = useLocation();
  const addToast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(async () => {
    const resp = await api.get(
      BaseRequests.getUrlSearch('/factdata/teammembers', { projId }),
    );
    const inst = await api.get('/structure/institutes');
    setTeamMembers(resp?.data.filter((value) => value.status === 'approved').map((value) => ({
      label: `${value.lastName} ${value.firstName} ${value.middleName} (${value.post})`,
      value,
    })));
    setInstitutes(inst.map((e) => ({
      label: e.title,
      value: e.id,
    })));
  }, []);

  const getQueryParams = (queryString) => {  
    return queryString  
      .split('?')[1]
      ?.split('&')
      ?.reduce((acc, pair) => {  
          const [key, value] = pair.split('=');  
          acc[decodeURIComponent(key)] = decodeURIComponent(value);  
          return acc;  
      }, {});  
  };

  const timeoutRef = useRef(null);
  const loadOptions = (inputValue, callback) => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(async () => {
      const resp = await api.get(`/ones/pas?search=${inputValue}`, true);
      setFoundedValues(resp);
      callback(resp.map((value) => ({ label: value.name, value: value.uid })));
    }, 1000);
  };

  const handleEditField = (event) => {
    setSelectedHead(event);
  };

  const handleSave = async () => {
    addToast.info('Идёт сохранение...');
    setIsLoading(true);
    try {
      const result = await api.post('/factdata/contracts', {
        projId,
        year: getQueryParams(location.search).year,
        paCode: selectedValue.code,
        topic: topicName,
        personsInCharge: [{
          id: selectedHead.value.id,
          institute: selectedInstitute.label,
        }],
      });
      result.hasOwnProperty('error')
        ? addToast.error(result.error.message)
        : (
          addToast.success('Поступление сохранено'),
          history.push(`${history.location.pathname.split('/nreceipt')[0]}/receipts`)
        );
    } finally {
      setIsLoading(false);
    }
  };

  const selectValue = async (item) => {
    setSelectedValue(foundedValues.find((e) => e.uid === item?.value));
  };

  return (
    <div>
      <h3 style={{ color: 'black', margin: '20px 0 36px', textAlign: 'start' }}>Заполнение карточки поступления</h3>
      <div style={{ marginBottom: '20px' }}>
        <FindWithSelectComponent
          noOptionsMessage={() => 'Ничего не найдено'}
          placeholder="Введите внутренний номер л/c, присваиваемый в УрФУ"
          value={selectedValue ? { value: selectedValue.uid, label: selectedValue.name } : ''}
          defaultOptions={[]}
          loadOptions={loadOptions}
          onChange={(selectedValue) => {
            selectValue(selectedValue);
          }}
          clearInputState={() => {
            setSelectedValue(Object.keys(selectedValue).forEach((e) => delete selectedValue[e]));
            setTopicName('');
            setSelectedHead({});
            setSelectedInstitute({});
          }}
          marginRowZero
        />
      </div>
      { selectedValue === undefined || !Object.keys(selectedValue).length ? null
        : (
          <div>
            <Card style={{ marginBottom: '20px' }}>
              <Card.Body style={{
                padding: '30px 25px', display: 'flex', flexDirection: 'column', rowGap: '24px',
              }}
              >
                <Form.Group as={Col}>
                  <Form.Label style={{ color: '#7F7F7F' }}>
                    Наименование темы
<Required />
                  </Form.Label>
                  <Form.Control
                    as="input"
                    required
                    name="topic"
                    value={topicName}
                    onChange={(event) => setTopicName(event.target.value)}
                    />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label style={{ color: '#7F7F7F' }}>
                    Руководитель темы
<Required />
                  </Form.Label>
                  <Select
                    placeholder="Выберите из списка участников проекта"
                    options={teamMembers}
                    onChange={(event) => handleEditField(event)}
                    onInputChange={(selectedValue) => {
                        setSearchHeadValue(selectedValue);
                      }}
                    />
                </Form.Group>
                <Form.Group as={Col}>
                  <SelectWithCustomInput
                    label="Институт (где работает руководитель темы)"
                    placeholder="Выберите институт из списка или введите свое значение."
                    defaultOptions={institutes}
                    defaultValue={[]}
                    onInputChange={(selectedValue) => {
                        setSearchInstitute(selectedValue);
                      }}
                    onChange={(val) => setSelectedInstitute(val)}
                    />
                </Form.Group>
              </Card.Body>
            </Card>
            <Card>
              <Card.Body style={{ display: 'flex', columnGap: '8px', padding: '30px 25px' }}>
                <Button
                  onClick={() => {
                    setIsLoading(true);
                    new Promise((resolve) => {
                      resolve(history.goBack());
                    }).finally(() => setIsLoading(false));
                  }}
                  type="button"
                  variant="outline-secondary"
                  disabled={isLoading}
                >
                  Отменить
                </Button>
                <Button type="submit" onClick={handleSave} variant="outline-primary" disabled={isLoading}>Сохранить</Button>
              </Card.Body>
            </Card>
          </div>
        )}
    </div>
  );
}

export default ReceiptsAddContract;
